import React, { useEffect, useRef, useMemo, useState } from "react";
import Tabs from "./tabs";
import { useBlog } from "../../hooks/useCms";
import moment from "moment";
import URI from "urijs";
import Loader from "../../components/global/loader";
import { slugToCountryPathname } from "../../utils/strings";

export default function BlogCardsSection({ content }) {
  const searchObject = new URI().search(true);
  const { subtitle, title, tabs } = content;
  const newsContentRef = useRef();
  const activeIndex = useMemo(() => Number(searchObject.tag || 0), [searchObject.tag]);
  const [dataBinding, setdataBinding] = useState([]);
  const [currentTab, setCurrentTab] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showLoader, setShowLoader] = useState(false);
  const { entries } = useBlog(tabs, activeIndex, activeIndex !== currentTab ? 1 : currentPage);

  const buttonDetails = tabs.map((tab, i) => {
    return {
      ...tab,
      classes: `secondary sm ${activeIndex === i ? "active" : ""}`
    };
  });

  const handleChangePage = () => {
    setCurrentPage(currentPage + 1);
    setShowLoader(true);
  };

  const renderTemplateCard = (entry, index) => (
    <div key={index} className="blogCard">
      <div className="blogCardImg">
        <img src={entry.header?.heroImage?.url} alt="Speedoc blog post" />
      </div>
      <div className="blogCardContent">
        <div className="tagContainer">
          {entry.filterTags.map((item, i) => (
            <div key={i} className="covidTitle">
              {item.tag}
            </div>
          ))}
        </div>
        <div className="blogTitle">
          <a href={slugToCountryPathname(entry.slug)} target="_blank" rel="noreferrer">
            {entry.title}
          </a>
        </div>
        <div className="blogDate">{moment(entry.publicationDate).format("DD MMM YYYY")}</div>
      </div>
    </div>
  );

  useEffect(() => {
    if (entries) {
      if (activeIndex !== currentTab) {
        setShowLoader(true);
        setdataBinding([]);
        setCurrentTab(activeIndex);
        setCurrentPage(1);
      }
    }
  }, [activeIndex]);

  useEffect(() => {
    if (entries) {
      setShowLoader(false);
      setdataBinding(dataBinding.concat(entries));
    }
  }, [entries]);

  return (
    <div className="container" id="blogCardsSection" ref={newsContentRef}>
      <div className="subtitle">{subtitle}</div>
      <div className="title">{title}</div>
      <Tabs flexDirection="row" buttonDetails={buttonDetails} activeIndex={activeIndex} />
      <div className="newsSectionCards">{(dataBinding || []).map((entry, i) => renderTemplateCard(entry, i))}</div>
      {showLoader ? (
        <Loader />
      ) : (
        <div className="buttonContainer" onClick={() => handleChangePage()}>
          <div className="btn loadMore">Load More</div>
        </div>
      )}
    </div>
  );
}
